import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import AssembliesCards from 'components/Maps/ProductIdentity/AssembliesMap/AssembliesCards.jsx';
import PickupCard from 'components/Maps/ProductIdentity/AssembliesMap/PickupCard.jsx';

export const AssembliesList = ({
    nearbyAssemblies,
    currentItemId,
    onChooseDate,
    isVisible = true,
}) => {
    const nearbyAssembliesList = nearbyAssemblies?.map(assembly =>
        assembly.type === 'assembly' ? (
            <AssembliesCards
                selected={currentItemId === assembly.uuid}
                key={assembly.uuid}
                assemblyData={assembly}
                onChooseDate={onChooseDate}
            />
        ) : (
            <PickupCard
                selected={currentItemId === assembly.uuid}
                key={assembly.uuid}
                pickupData={assembly}
                onChooseDate={onChooseDate}
            />
        )
    );

    return (
        <div className={classNames('assemblies-list-container', { visible: isVisible })}>
            {nearbyAssembliesList}
        </div>
    );
};

AssembliesList.propTypes = {
    nearbyAssemblies: PropTypes.array,
    currentItemId: PropTypes.number,
    onChooseDate: PropTypes.func,
    isVisible: PropTypes.bool,
};
AssembliesList.defaultProps = {
    onChooseDate: () => null,
};

export default React.memo(AssembliesList);
